import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const drawerWidth = 240;

const styles = theme => ({
    drawerPaper: {
        position: 'relative',
        width: drawerWidth,
        height: window.innerHeight + 'px',
        marginTop: '-64px'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    }
});

@inject('menu')
@observer
class Bar extends React.Component {

    handleClick = (t) => {
        this.props.menu.changeText(t);
        this.handleDrawerClose();
    }

    handleDrawerClose = () => {
        this.props.menu.datas.open = !1;
    };

    render() {
        const { classes, theme } = this.props;
        const { open } = this.props.menu.datas;

        return (
            <Drawer
                variant="persistent"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <Typography variant="title" color="inherit" component="a" href="#/" onClick={() => this.handleClick(1)}>
                        Spotlight
                    </Typography>
                    <IconButton onClick={this.handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem button component="a" href="#/about" onClick={() => this.handleClick(2)}  >
                        <ListItemText primary="了解它" />
                    </ListItem>
                    <ListItem button component="a" href="#/article_list" onClick={() => this.handleClick(3)}>
                        <ListItemText primary="一些文章&示例" />
                    </ListItem>
                </List>
            </Drawer>
        );
    }
}

Bar.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Bar);